import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { CustomToastService } from '../../../../../services/custom-toast.service';
import { SharedContentCategory } from '../../../enums/shared-content-category.enum';
import { SharedContentModel } from '../../../models/general/shared-content-model';
import { SharedContentTypeModel } from '../../../models/general/shared-content-type-model';
import { SettingValueModel } from '../../../models/informate';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { requireCheckboxesToBeCheckedValidator } from 'src/app/Modules/idms/core/atleastOneChecked.validator';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-shared-content-add-update',
    templateUrl: './shared-content-add-update.component.html',
    styleUrls: ['./shared-content-add-update.component.scss'],
    standalone: false
})
export class SharedContentAddUpdateComponent {
    @Input() language: SettingValueModel;
    @Input() sharedContent: SharedContentModel;
    @Input() sharedContentType: string;
    @Input()
    set generalTabIndex(value: number) {
        this._generalTabIndex = value;
        this.loadHeaderName();
    }
    get generalTabIndex(): number {
        return this._generalTabIndex;
    }

    @Output() refreshSharedContents: EventEmitter<number> = new EventEmitter();
    @Output() refreshSharedContentsUpdate: EventEmitter<number> = new EventEmitter();
    @Output() refreshSharedContentsCreate: EventEmitter<number> = new EventEmitter();

    tooltip_position = 'above';
    headerName: string;
    closeResult: string;
    imageSrc: string;
    fileName: string;
    imageBlob: Blob;
    loadedImage: any;
    srdContentForm: UntypedFormGroup;
    result: ResultType = ResultType.Error;
    hideEditOption: boolean;
    hideDeleteOption: boolean;
    sharedContentTypeList: SharedContentTypeModel[];
    stateOptions: any[];
    method: string;
    private _generalTabIndex: number;

    constructor(
        private modalService: NgbModal,
        private fb: UntypedFormBuilder,
        private mgmtApi: ManagementApiService,
        private customToastService: CustomToastService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmittersService: GlobalEmittersService,
        private user_utlity: UserUtilityService,
        private user_utility: UserUtilityService,
        private customValidator: CustomValidatorService,
        private transLocoService: TranslocoService
    ) {
        this.stateOptions = [
            { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.FREE'), value: 'Free' },
            { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.PURCHASE'), value: 'Purchase' },
        ];
        this.method = this.sharedContent?.method;
    }

    loadFormData(): void {
        this.srdContentForm = this.fb.group({
            image: [this.sharedContent?.image, Validators.required],
            checkBoxGroup: new UntypedFormGroup(
                {
                    homePageCheck: new UntypedFormControl(false, [Validators.required]),
                    landingPageCheck: new UntypedFormControl(false, [Validators.required]),
                },
                requireCheckboxesToBeCheckedValidator()
            ),
            heading: [this.sharedContent?.heading, Validators.required],
            subHeading: [this.sharedContent?.subHeading],
            navigationText: [this.sharedContent?.navigationText, Validators.required],
            navigationLink: [this.sharedContent?.navigationLink, Validators.required, asyncUrlValidator],
            sharedContentType: [this.sharedContent?.sharedContentTypeId],
            date: [this.sharedContent?.date],
            method: [this.sharedContent?.method],
            price: [this.sharedContent?.price ? this.sharedContent?.price : ''],
        });
        this.imageSrc = this.sharedContent?.image;
        this.method = this.sharedContent?.method;
        this.handleFormValidators();
        this.srdContentForm.get('method').valueChanges.subscribe((val) => {
            if (val) this.method = val;
        });
    }

    async getSharedContentTypes(categoryKey: string) {
        await this.mgmtApi.getSharedContentTypes(categoryKey).subscribe((sharedContentTypes) => {
            if (sharedContentTypes.success === true) {
                this.sharedContentTypeList = sharedContentTypes.response;
                if (this.sharedContent?.sharedContentType?.sharedContentTypeId != null)
                    this.srdContentForm.get('sharedContentType').setValue(this.sharedContent.sharedContentType.sharedContentTypeId, { emitEvent: true });
            } else {
                this.user_utlity.errorModelPopup(sharedContentTypes.message);
            }
        });
    }

    async loadHeaderName() {
        switch (this.generalTabIndex) {
            case 0:
                this.globalEmittersService.sharedContentType.next(SharedContentCategory.HeroImages);
                await this.checkUserPermissions('heroImages');
                this.headerName = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.HERO_IMAGE');
                break;
            case 1:
                this.globalEmittersService.sharedContentType.next(SharedContentCategory.NewsUpdates);
                await this.checkUserPermissions('news');
                this.headerName = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.NEWS_UPDATES');
                break;
            case 2:
                this.globalEmittersService.sharedContentType.next(SharedContentCategory.Pricing);
                await this.checkUserPermissions('Pricing');
                this.headerName = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.PRICING_DETAILS');
                break;
            case 3:
                this.headerName = this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.SOCIAL_MEDIA');
                break;
        }
    }

    getSharedContentCategory(): SharedContentCategory {
        switch (this.generalTabIndex) {
            case 0:
                return SharedContentCategory.HeroImages;
            case 1:
                return SharedContentCategory.NewsUpdates;
            case 2:
                return SharedContentCategory.Pricing;
            case 3:
                return SharedContentCategory.SocialMedia;
        }
    }

    async btnAddClicked() {
        if (this.srdContentForm.valid) {
            let sharedContent = new SharedContentModel();
            if (this.generalTabIndex == 0) {
                let subHeadingVal: string = this.srdContentForm.get('subHeading')?.value;
                sharedContent.subHeading = subHeadingVal?.trim().toLowerCase() == 'null' || subHeadingVal == 'undefiend' ? '' : subHeadingVal;
                // setting up imageLocation value
                if (
                    this.srdContentForm.get('checkBoxGroup').get('homePageCheck').value &&
                    this.srdContentForm.get('checkBoxGroup').get('landingPageCheck').value
                ) {
                    sharedContent.imageLocation = 3;
                } else if (this.srdContentForm.get('checkBoxGroup').get('homePageCheck').value) {
                    sharedContent.imageLocation = 1;
                } else if (this.srdContentForm.get('checkBoxGroup').get('landingPageCheck').value) {
                    sharedContent.imageLocation = 2;
                }
            } else if (this.generalTabIndex == 1) {
                sharedContent.sharedContentTypeId = this.srdContentForm.get('sharedContentType').value;

                sharedContent.date = this.srdContentForm.get('date').value;
            } else if (this.generalTabIndex == 2) {
                this.method === 'Purchase' ? (sharedContent.isPurchase = true) : (sharedContent.isPurchase = false);
                if (sharedContent.isPurchase === true) {
                    sharedContent.price = this.srdContentForm.get('price').value;
                }
                sharedContent.subHeading = this.srdContentForm.get('subHeading').value;
            }
            sharedContent.heading = this.srdContentForm.get('heading').value;
            sharedContent.navigationText = this.srdContentForm.get('navigationText').value;
            sharedContent.navigationLink = this.srdContentForm.get('navigationLink').value;
            sharedContent.language = this.language;
            sharedContent.image = this.srdContentForm.get('image').value;
            sharedContent.imageBlob = this.imageBlob;
            sharedContent.imageFileName = this.fileName;
            await this.createSharedContent(sharedContent);
            this.resetAll(false);
        }
    }

    async btnUpdateClicked() {
        if (this.srdContentForm.valid) {
            this.sharedContent.heading = this.srdContentForm.get('heading').value;
            if (this.generalTabIndex == 1) {
                this.sharedContent.sharedContentTypeId = this.srdContentForm.get('sharedContentType').value;

                this.sharedContent.date = this.srdContentForm.get('date').value;
            }
            if (this.generalTabIndex == 0) {
                this.sharedContent.subHeading = this.srdContentForm.get('subHeading').value;

                // setting up imageLocation value
                if (
                    this.srdContentForm.get('checkBoxGroup').get('homePageCheck').value &&
                    this.srdContentForm.get('checkBoxGroup').get('landingPageCheck').value
                ) {
                    this.sharedContent.imageLocation = 3;
                } else if (this.srdContentForm.get('checkBoxGroup').get('homePageCheck').value) {
                    this.sharedContent.imageLocation = 1;
                } else if (this.srdContentForm.get('checkBoxGroup').get('landingPageCheck').value) {
                    this.sharedContent.imageLocation = 2;
                }
            }
            if (this.generalTabIndex == 2) {
                this.method === 'Purchase' ? (this.sharedContent.isPurchase = true) : (this.sharedContent.isPurchase = false);
                if (this.sharedContent.isPurchase === true) {
                    this.sharedContent.price = this.srdContentForm.get('price').value;
                }
                this.sharedContent.subHeading = this.srdContentForm.get('subHeading').value;
            }
            this.sharedContent.navigationText = this.srdContentForm.get('navigationText').value;
            this.sharedContent.navigationLink = this.srdContentForm.get('navigationLink').value;
            if (this.imageBlob !== null && this.fileName !== null) {
                this.sharedContent.image = this.srdContentForm.get('image').value;
                this.sharedContent.imageBlob = this.imageBlob;
                this.sharedContent.imageFileName = this.fileName;
            }
            await this.updateSharedContent(this.sharedContent);

            this.resetAll(false);
        }
        this.ngxUiLoaderService.stop();
    }

    btnDeleteImage() {
        this.srdContentForm.get('image').reset();
        this.imageSrc = null;
        this.imageBlob = null;
        this.fileName = null;
    }

    btnCancelClicked() {
        this.resetAll(true);
    }

    resetAll(isCancelClicked: boolean) {
        this.modalService.dismissAll(true);
        // this.activeModal)
        if (isCancelClicked != true) {
            this.srdContentForm.reset();
        }
        this.imageSrc = null;
        this.imageBlob = null;
        this.fileName = null;
    }

    async updateSharedContent(sharedContent: SharedContentModel) {
        this.ngxUiLoaderService.start();
        this.mgmtApi
            .updateSharedContent(sharedContent, this.getSharedContentCategory())
            .toPromise()
            .then(
                (res) => {
                    if (res.success === true) {
                        this.ngxUiLoaderService.stop();
                        this.customToastService.successToast('Successfully updated!');
                        this.refreshSharedContentsUpdate.emit(this.generalTabIndex);
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                    this.user_utlity.errorModelPopup(err.message);
                }
            );
    }

    createSharedContent(sharedContent: SharedContentModel) {
        this.ngxUiLoaderService.start();
        this.mgmtApi
            .createSharedContent(sharedContent, this.getSharedContentCategory())
            .toPromise()
            .then(
                (res) => {
                    if (res.success === true) {
                        this.refreshSharedContentsUpdate.emit(this.generalTabIndex);
                        this.customToastService.successToast('Successfully added!');
                        this.globalEmittersService.refreshContentGeneralSetting.next(true);
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.user_utlity.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                    this.user_utlity.errorModelPopup(err.message);
                }
            );
    }

    changeValue($event) {
        this.method = $event.value;
    }

    onSelectFile(event) {
        const reader = new FileReader();
        const [file] = event.target.files;
        let _file = <File>event.target.files[0];
        let allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        let errorMessage = 'Please select a .jpeg, .jpg, .png, .webp file.';
        if (!allowedTypes.includes(_file.type)) {
            this.customToastService.errorToast(errorMessage, 'Error');
            return;
        }
        reader.onload = () => {
            this.loadedImage = new Image();
            this.loadedImage.src = reader.result as string;
            this.loadedImage.onload = () => {
                let dimension = {
                    width: this.loadedImage.width,
                    height: this.loadedImage.height,
                };
                if (this.imageValidationHandler(dimension, file.size / (1024 * 1024), event.target.files[0].type)) {
                    this.srdContentForm.markAsDirty();
                    this.imageSrc = reader.result as string;
                    this.srdContentForm.patchValue({
                        image: reader.result,
                    });
                    this.imageBlob = file;
                    this.fileName = file.name;
                }
            };
        };
        reader.readAsDataURL(file);
    }

    async open(content) {
        await this.loadData();
        this.loadFormData();
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    async loadData() {
        await this.getSharedContentTypes(SharedContentCategory.NewsUpdates);
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    // * method to handle validation because the form is common for all shared-content items
    handleFormValidators() {
        switch (this.generalTabIndex) {
            // * Hero-image tab
            case 0:
                // * removing the unnecessary validators
                this.srdContentForm.get('date').clearValidators();
                this.srdContentForm.updateValueAndValidity();
                // * setting up imageLocation value
                if (this.generalTabIndex == 0 && this.sharedContent != null) {
                    if (this.sharedContent.imageLocation == 3) {
                        this.srdContentForm.get('checkBoxGroup').get('homePageCheck').setValue(true);
                        this.srdContentForm.get('checkBoxGroup').get('landingPageCheck').setValue(true);
                    } else if (this.sharedContent.imageLocation == 1) {
                        this.srdContentForm.get('checkBoxGroup').get('homePageCheck').setValue(true);
                    } else if (this.sharedContent.imageLocation == 2) {
                        this.srdContentForm.get('checkBoxGroup').get('landingPageCheck').setValue(true);
                    }
                }
                break;
            // * News and Update tab
            case 1:
                // * removing the unnecessary validators
                this.srdContentForm.get('checkBoxGroup').clearValidators();
                this.srdContentForm.updateValueAndValidity();
                break;
            // * Pricing details tab
            case 2:
                // * removing the unnecessary validators
                this.srdContentForm.get('method').setValidators([Validators.required]);
                this.srdContentForm.get('heading').setValidators([Validators.required]);
                this.srdContentForm.get('subHeading').setValidators([Validators.required]);
                this.srdContentForm.get('checkBoxGroup').clearValidators();
                this.srdContentForm.get('navigationLink').setValue(environment.contactUsLink);
                this.srdContentForm.get('navigationLink').disable();
                this.srdContentForm.updateValueAndValidity();

                this.srdContentForm.get('method').valueChanges.subscribe((res) => {
                    if (this.srdContentForm.get('method').value == 'Purchase') {
                        this.srdContentForm.get('price').setValidators([Validators.required]);
                    } else {
                        this.srdContentForm.get('price').clearValidators();
                        this.srdContentForm.get('price').updateValueAndValidity();
                    }
                });
                break;
            // * Social Media tab
            case 3:
                break;
        }
    }

    // * handle image validations
    imageValidationHandler(dimension: { width: number; height: number }, fileSize: number, type: string = '') {
        let result: boolean = true;
        switch (this.generalTabIndex) {
            case 0:
                if (dimension.width < 1280 || dimension.height < 720 || fileSize > 5) {
                    let dialogRef = this.modalService.open(ErrorDialogComponent, {
                        size: 'sm',
                    });
                    dialogRef.componentInstance.message = 'Image Criteria - Minimum width: 1280px and height: 720px and size <=5MB';
                    result = false;
                }
                break;
            // there is novaidation avaible for the news and updates tab
            case 1:
            case 3:
                result = true;
                break;
            case 2:
                if (dimension.width > 350 || dimension.height > 100 || fileSize > 5) {
                    let dialogRef = this.modalService.open(ErrorDialogComponent, {
                        size: 'sm',
                    });
                    dialogRef.componentInstance.message = 'Image Criteria - Maximum width: 350px and height: 100px and size <=5MB';
                    result = false;
                }
                break;
        }
        return result;
    }

    async checkUserPermissions(permission: string) {
        this.hideEditOption = await this.user_utility.checkUserPermissionDataAndRoute(permission, userActions.Edit);
        this.hideDeleteOption = await this.user_utility.checkUserPermissionDataAndRoute(permission, userActions.Delete);
    }

    fromControlsValidationHandler(event, index) {
        let keyCode = event.charCode;
        switch (index) {
            // when user press any keys
            case 1:
                return (
                    (keyCode > 64 && keyCode < 91) ||
                    (keyCode > 96 && keyCode < 123) ||
                    keyCode == 8 ||
                    keyCode == 32 ||
                    keyCode == 36 ||
                    keyCode == 46 ||
                    (keyCode >= 48 && keyCode <= 57)
                );

            //when paste event accure
            case 2:
                let clipboardData1 = event.clipboardData;
                let pastedText1 = clipboardData1.getData('text');
                let format1 = /[!@#%^&*()_+\-=\[\]{};':"\\|,<>\/?]+/;
                return format1.test(pastedText1) ? (event.preventDefault(), this.displayToast()) : null;

            default:
                break;
        }
    }
    // * helper method to display toast
    displayToast() {
        this.customToastService.infoToast('In Special characters only $ is allowed!', 'Info');
    }

    onKeyPress(event) {
        this.customValidator.validateKeyPress(event);
    }

    consoleForm() {}
}
export function asyncUrlValidator(control: AbstractControl): Observable<ValidationErrors | null> {
    return of(control.value).pipe(
        // delay(1000), // Simulating an async call
        map((value) => {
            const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(:\d{1,5})?(\/.*)?$/i;
            return urlPattern.test(value) ? null : { invalidUrl: true };
        })
    );
}
